import { render } from "./SurveyPrepare.vue?vue&type=template&id=228d221a&scoped=true"
import script from "./SurveyPrepare.vue?vue&type=script&lang=js"
export * from "./SurveyPrepare.vue?vue&type=script&lang=js"

import "./SurveyPrepare.vue?vue&type=style&index=0&id=228d221a&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228d221a"]])

export default __exports__